import { useEffect } from 'react';
import { userStore } from 'stores';
import { secureLs } from 'utils';

import { $api } from '../http';

function getTokenExpiry(token: string): number | null {
	try {
		const base64 = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/');
		const payload = JSON.parse(atob(base64));
		return payload.exp ?? null;
	} catch {
		return null;
	}
}

async function renewToken() {
	const token = secureLs.get('token');
	if (!token || !userStore.isAuth) {return;}

	const exp = getTokenExpiry(token);
	if (!exp) {return;}

	const secondsLeft = exp - Math.floor(Date.now() / 1000);
	if (secondsLeft > 24 * 60 * 60) {return;}

	try {
		const res = await $api.post<{ token: string }>('/spm/v1/renew-token');
		secureLs.set('token', res.data.token);
	} catch {
	}
}

export const useTokenRenewal = () => {
	useEffect(() => {
		renewToken();
		window.addEventListener('focus', renewToken);
		return () => window.removeEventListener('focus', renewToken);
	}, []);
};
